import { useEffect, useState } from "react";
import axios from "axios";
import { Trophy } from "lucide-react";
import { Link } from "react-router-dom";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const RANK_STYLES = ["text-rr-orange", "text-rr-navy", "text-rr-navy"];

export const TopReferrers = () => {
  const [referrers, setReferrers] = useState([]);

  useEffect(() => {
    axios
      .get(`${API}/leads/referrers/top`)
      .then((res) => setReferrers(res.data?.referrers || []))
      .catch(() => setReferrers([]));
  }, []);

  if (referrers.length === 0) return null;

  return (
    <section id="top-referrers" data-testid="top-referrers-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-5 md:px-8 text-center">
        <SectionHeading
          eyebrow="Founding Driver Referral Board"
          title="Top Referrers"
          description="These founding drivers are helping build the RelayRigs network fastest by inviting others to pre-register."
          align="center"
          testId="top-referrers"
        />

        <Reveal delay={0.15}>
          <div className="mt-10 max-w-md mx-auto bg-rr-surface rounded-2xl border border-rr-line p-6 text-left">
            <ol className="space-y-3">
              {referrers.map((r, idx) => (
                <li
                  key={`${r.name}-${idx}`}
                  data-testid={`top-referrer-rank-${idx}`}
                  className="flex items-center justify-between gap-2 flex-wrap bg-white rounded-xl border border-rr-line px-4 py-3"
                >
                  <span className="flex items-center gap-3">
                    <span className={`flex items-center gap-1 font-bold text-sm ${RANK_STYLES[idx] || "text-rr-muted"}`}>
                      {idx < 3 ? <Trophy size={15} /> : <span className="w-[15px] text-center">{idx + 1}</span>}
                    </span>
                    <span className="font-semibold text-rr-navy text-sm">{r.name}</span>
                    {idx < 3 && (
                      <span data-testid={`top-referrer-badge-${idx}`} className="text-[10px] font-bold uppercase tracking-wide text-rr-orange bg-rr-orange/10 rounded-full px-2 py-0.5 whitespace-nowrap">
                        Founding Ambassador
                      </span>
                    )}
                    {r.on_streak && (
                      <span data-testid={`top-referrer-streak-${idx}`} className="text-[10px] font-bold uppercase tracking-wide text-rr-red bg-rr-red/10 rounded-full px-2 py-0.5 whitespace-nowrap">
                        🔥 On a Streak
                      </span>
                    )}
                  </span>
                  <span className="text-xs font-bold text-rr-orange bg-rr-orange/10 rounded-full px-3 py-1">
                    {r.count} referral{r.count === 1 ? "" : "s"}
                  </span>
                </li>
              ))}
            </ol>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <Link
            to="/ambassador-program"
            data-testid="top-referrers-learn-more-link"
            className="inline-flex items-center gap-1.5 text-sm font-bold text-rr-orange mt-6 hover:text-rr-navy transition-colors"
          >
            Learn about Founding Ambassador perks →
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
